import { studentProfileBuilderStore } from './studentProfileBuilderStore'
import { fetchOrganizationStudentsProfileBuilder } from 'api/users'

let inflight = null

export async function ensureStudentProfileBuilderLoaded({ force = false } = {}) {
	if (!force && studentProfileBuilderStore.profiles.size > 0) {
		return studentProfileBuilderStore.profiles
	}

	if (inflight) {
		return inflight
	}

	studentProfileBuilderStore.setLoading(true)
	inflight = (async () => {
		try {
			const response = await fetchOrganizationStudentsProfileBuilder()
			const profiles = response?.profiles || []
			studentProfileBuilderStore.setProfiles(profiles)
			studentProfileBuilderStore.setLoadStatus('success')
			return profiles
		} catch (error) {
			console.error('Failed to load profile builder data:', error)
			studentProfileBuilderStore.setLoadStatus('error')
			throw error
		} finally {
			studentProfileBuilderStore.setLoading(false)
			inflight = null
		}
	})()

	return inflight
}
